@if (isDisabled) {
<app-loader></app-loader>
}
<div class="card shadow border-0 m-1">
    <div class="card-body">
        <div class="row">
            <div class="col-auto">
                <h6><i class="bi bi-person-raised-hand fs-5 me-1"></i>Client Help Desk</h6>
            </div>
            <div class="col"></div>
            <div class="col-auto">
                <button class="btn btn-secondary btn-sm me-2">Total:{{globalTotal}}</button>
                <button class="btn btn-secondary btn-sm me-2">Open:{{globalOpen}}</button>
                <button class="btn btn-secondary btn-sm me-2">Assigned:{{globalAssign}}</button>
                <button class="btn btn-secondary btn-sm me-2">Resolved:{{globalResolved}}</button>
                <button class="btn btn-secondary btn-sm me-2">Closed:{{globalClose}}</button>
            </div>
            <!-- <div class="col-auto">
                <div class="form-check form-switch d-inline-flex align-items-center">
                    <input class="form-check-input" type="checkbox" role="switch" id="filterToggle"
                        [(ngModel)]="showFilter">
                    <label class="ms-2 Label" for="filterToggle">Filter</label>
                </div>
            </div> -->
        </div>
        <hr>
       

        <div class="row mt-3 gap-3 cards mx-1">
            <div class="row">
                <div class="col-auto"><span class="Label">Count from ({{FromDateObj}} - {{ToDateObj}})</span></div>
                <div class="col"></div>
                <div class="col-auto">
                    <div class="form-check form-switch d-inline-flex align-items-center">
                    <input class="form-check-input" type="checkbox" role="switch" id="filterToggle"
                        [(ngModel)]="showFilter">
                    <label class="ms-2 Label" for="filterToggle">Filter</label>
                </div>
                </div>
            </div>
            <!-- <span class="Label">Count from ({{FromDateObj}} - {{ToDateObj}})</span> -->
            <div class="card shadow border-0 mb-3 col-md-2">
                <div class="card-body d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <div
                            class="icon-wrapper bg-light rounded-circle d-flex justify-content-center align-items-center me-3">
                            <i class="bi bi-opencollective text-primary fs-4"></i>
                        </div>
                        <div>
                            <div class="text-primary fw-bold small">Open</div>
                            <div class="text-primary h5 mb-0">{{Open}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card shadow border-0 mb-3 col-md-2">
                <div class="card-body d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <div
                            class="icon-wrapper bg-light rounded-circle d-flex justify-content-center align-items-center me-3">
                            <i class="bi bi-people text-danger fs-4"></i>
                        </div>
                        <div>
                            <div class="text-danger fw-bold small">Assigned</div>
                            <div class="h5 mb-0 text-danger">{{Assigned}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card shadow border-0 mb-3 col-md-2">
                <div class="card-body d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <div
                            class="icon-wrapper bg-light rounded-circle d-flex justify-content-center align-items-center me-3">
                            <i class="bi bi-person-x text-warning fs-4"></i>
                        </div>
                        <div>
                            <div class="text-warning fw-bold small">Resolved</div>
                            <div class="h5 mb-0 text-warning">{{Resolved}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="card shadow border-0 mb-3 col-md-2">
                <div class="card-body d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <div
                            class="icon-wrapper bg-light rounded-circle d-flex justify-content-center align-items-center me-3">
                            <i class="bi bi-cup-hot text-warning fs-4"></i>
                        </div>
                        <div>
                            <div class="text-warning fw-bold small">Resolved</div>
                            <div class="h5 mb-0 text-warning">{{Resolved}}</div>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="card shadow border-0 mb-3 col-md-2">
                <div class="card-body d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <div
                            class="icon-wrapper bg-light rounded-circle d-flex justify-content-center align-items-center me-3">
                            <i class="bi bi-person-check text-success fs-4"></i>
                        </div>
                        <div>
                            <div class="text-success fw-bold small">Closed</div>
                            <div class="h5 mb-0 text-success">{{Close}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

         <div *ngIf="showFilter">
            <div class="row mt-2 mx-1">
                <div class="col-md-4">
                    <label class="Label mb-1">Complaint Type</label>
                    <div class="input-group">
                        <ng-select class="w-100" [items]="ComplaintTypes" bindLabel="" bindValue=""
                            [(ngModel)]="ComplaintType" placeholder="Select Complaint Type" name="complainttype"
                            #complainttype="ngModel" required >
                        </ng-select>
                        <div class="invalid-feedback fs-7">
                            Please select complaint!
                        </div>
                    </div>
                </div>

                <div class="col-md-2">
                    <label class="Label mb-1">Status</label>
                    <div class="input-group">
                        <ng-select class="w-100" [items]="TicketStatusLoad" bindLabel="value" bindValue="value"
                            [(ngModel)]="TicketStatus" placeholder="Status" name="complainttype"
                            #complainttype="ngModel" required >
                        </ng-select>
                        <div class="invalid-feedback fs-7">
                            Please select complaint!
                        </div>
                    </div>
                </div>

                <div class="col-md-2" *ngIf="!showDate">
                    <label class="Label mb-1">From Date</label>
                    <div class="input-group" style="height: auto;">
                        <input class="form-control" name="DateFrom" placeholder="Ex. DD MMM YYYY" ngbDatepicker
                            #d="ngbDatepicker" [(ngModel)]="FromDate" [minDate]="{ year:1930, month: 12, day: 31 }"
                            [maxDate]="{ year: 2124, month: 12, day: 31 }" readonly/>
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                            type="button"></button>
                    </div>
                </div>

                <div class="col-md-2" *ngIf="!showDate">
                    <label class="Label mb-1">To Date</label>
                    <div class="input-group" style="height: auto;">
                        <input class="form-control" name="DateTo" placeholder="Ex. DD MMM YYYY" ngbDatepicker
                            #d3="ngbDatepicker" [(ngModel)]="ToDate" [minDate]="{ year:1930, month: 12, day: 31 }"
                            [maxDate]="{ year: 2124, month: 12, day: 31 }" readonly/>
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d3.toggle()"
                            type="button"></button>
                    </div>
                </div>

                <div class="col-md-3" *ngIf="showDate">
                    <label class="Label mb-1">Month and Year</label>
                    <!-- <ngb-datepicker #dp [(ngModel)]="selectedMonth" class="month-year"
                    (navigate)="selectedMonth= $event.next;onNavigate()"></ngb-datepicker> -->
                    <input type="month" class="form-control" [(ngModel)]="selectedMonth" >
                </div>

                <div class="col-md-2 mt-2"><br>
                    <input class="form-check-input" style="height: 15px; width: 15px;" name="filter" type="checkbox"
                        [(ngModel)]="showDate" />&nbsp;&nbsp;<label style="font-size: 12px;">Filter by
                        Month</label>
                </div>
            </div>
            <div class="row mt-2 mx-1 d-flex align-items-center">
                <div class="col-md-6">
                    <label class="Label mb-1" for="">Select Branch</label>
                    <ng-select [items]="Branchs" [multiple]="true" bindLabel="BranchName" bindValue="BranchMasterID"
                        placeholder="Select Clients" [closeOnSelect]="false" [(ngModel)]="Filter.BranchID"
                        (change)="ComboLoad2('Client');onchange('Branch');clear()" name="Branchs">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                [ngModel]="item$.selected" />
                            {{item.BranchName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.BranchName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>

                <div class="col-md-6">
                    <label class="Label mb-1" for="">Select Client</label>
                    <ng-select [items]="Clients" [multiple]="true" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" placeholder="Select Clients" [closeOnSelect]="false"
                        [(ngModel)]="Filter.ClientID" (change)="ComboLoad2('Site');onchange('Client');clear();" name="Clients">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                [ngModel]="item$.selected" />
                            {{item.ClientGroupName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.ClientGroupName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>

                <!-- <div class="col-md-4">
                <label class="Label mb-1" for="">Select Site</label>
                <ng-select [items]="Sites" [multiple]="true" bindLabel="SiteName" bindValue="SiteMasterID"
                    placeholder="Select Site" [closeOnSelect]="false" [(ngModel)]="Filter.SiteID" name="Sites"
                    (change)="onchange('site')">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected" />
                        {{item.SiteName}}
                    </ng-template>
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                            <span class="ng-value-label">{{item.SiteName}}</span>
                        </div>
                        <div class="ng-value" *ngIf="items.length > 1">
                            <span class="ng-value-label">{{items.length - 1}} more...</span>
                        </div>
                    </ng-template>
                </ng-select>
            </div> -->

            </div>

            <div class="row mt-2 mx-1 d-flex align-items-center">
                <div class="col-md-6">
                    <label class="Label mb-1" for="">Select Site</label>
                    <!-- <ng-select [items]="Sites" bindLabel="SiteName" bindValue="PaymaxSiteMasterID"
                        placeholder="Select Site" name="site" [(ngModel)]="Filter.Site" required>
                    </ng-select> -->
                    <ng-select [items]="Sites" [multiple]="true" bindLabel="SiteName" bindValue="SiteMasterID"
                        placeholder="Select Site" [closeOnSelect]="false" [(ngModel)]="Filter.SiteID" name="Sites"
                        (change)="onchange('site');clear()">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                [ngModel]="item$.selected" />
                            {{item.SiteName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.SiteName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>

                <div style="margin-top: 30px;" class="col-md-2">
                    <button (click)="getData();" class="btn btn-secondary fs-7 btn-sm"> <i
                            class="bi bi-search me-1"></i>Search</button>
                </div>
            </div>

            <div class="row mt-2 mx-1">
                <!-- <div class="col-md-3">
                <label class="Label mb-1" for="">Complaint Type</label>
                <div class="input-group">
                    <ng-select class="w-100" [items]="ComplaintTypeData" bindLabel="ComplaintType"
                        bindValue="ESS_ComplaintTypeID" placeholder="Complaint Type" [(ngModel)]="ESS_ComplaintTypeId"
                        [virtualScroll]="true" name="ComplaintType" (change)="onchange('ComplaintType')">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Complaint Type
                    </div>
                </div>
            </div> -->

                <!-- <div class="col-md-2">
                <label class="Label mb-1" for="">Ticket Status</label>
                <div class="input-group">
                    <select style="font-size: 13px;" class="form-select" aria-label="TickecStatus"
                        placeholder="TickecStatus" title="TickecStatus" name="ticketstatus" [(ngModel)]="TickecStatus"
                        required (change)="onchange('Status')">
                        <option value="Open">Open</option>
                        <option value="Assigned">Assigned</option>
                        <option value="Resolved">Resolved</option>
                        <option value="Closed">Closed</option>
                        <option value="All">All</option>
                    </select>
                </div>
            </div> -->

            </div>
            <hr>
        </div>

        <!-- <hr> -->

        <div class="table-responsive mx-2">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                class="table table-bordered overflow-auto d-table" style="overflow: auto;">
                <thead class="table-light">
                    <tr>
                        <th style="width: 40px;">Action</th>
                        <th style="width: 70px;">Complaint Type</th>
                        <th style="width: 70px;">Branch</th>
                        <th style="width: 70px;">Client</th>
                        <th style="width: 70px;">Site</th>
                        <th style="width: 70px;">ContactNo</th>
                        <th>Description</th>
                        <th style="width: 70px;">Attachment</th>
                        <th style="width: 70px;">Status</th>
                        <th style="width: 70px;">AssignedTo</th>
                        <th style="width: 70px;">RequestedOn</th>
                        <th style="width: 70px;">Remark</th>
                        <th style="width: 70px;">Email</th>
                    </tr>
                </thead>
                <tbody>
                    <tr [ngClass]="{'highlight-row': data['PriorityFlag']  === 'PRIORITY'}" style="font-size: 12px;" *ngFor="let data of SupportData; let i = index">
                        <td style="text-align: center;">
                            <i (click)="onEditClick(data)" class="bi bi-pencil text-warning cursor-pointer fs-6"></i>
                        </td>
                        <!-- <td style="text-align: center">
                            <i (click)="Hist(data)" class="bi bi-hourglass-split text-warning cursor-pointer fs-6"></i>
                        </td> -->
                        <td>{{data['ComplaintType']}}</td>
                        <td>
                            <div style="width: 120px">
                                {{data['BranchName']}}
                            </div>
                        </td>
                        <td>
                            <div style="width: 120px">
                                {{data['ClientLocation']}}
                            </div>
                        </td>
                        <td>
                            <div style="width: 120px">
                                {{data['SiteName']}}
                            </div>
                        </td>
                        <td>{{data['ContactNo']}}</td>
                        <td>
                            <div style="width: 250px">
                                {{data['Description']}}
                            </div>
                        </td>
                        <td style="text-align: center"> <i (click)="viewfile(data['Attachment'])" *ngIf="data['Attachment'] !== ''" class="bi bi-paperclip text-primary cursor-pointer fs-6"></i></td>
                        <td [ngStyle]="{'color': data.Status === 'Open' ? 'orange' : 'green'}">{{data['Status']}}</td>
                        <td>{{data['AssignedTo']}}</td>
                        <td>{{data['RequestedOn']}}</td>
                        <td>{{data['Remarks']}}</td>
                        <td>{{data['Email']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>